<template>
  <v-app id="login-form" class="login-form">
    <v-main>
      <v-container style="height: 100%; display: grid" :fluid="true">
        <v-row align="center" justify="center" text-center>
          <v-col xs="12" sm="8" md="6">
            <v-card class="elevation-4 card--flex-toolbar">
              <!--              <v-app-bar flat color="transparent">-->
              <v-row>
                <v-col xs12 class="text-center mt-6">
                  <v-avatar size="48" color="grey">
                    <v-icon size="20" dark>fa-solid fa-lock</v-icon>
                  </v-avatar>
                </v-col>
              </v-row>
              <!--              </v-app-bar>-->
              <v-card-text class="pb-0">
                <!--                <v-form v-bind="valid">-->
                <v-row>
                  <v-col class="px-6">
                    <v-text-field
                      v-model="email"
                      type="text"
                      prepend-icon="fa-solid fa-user"
                      color="primary"
                      variant="underlined"
                      validate-on="blur lazy"
                      :label="emailPhoneLabel"
                      :disabled="loading"
                      :rules="emailRules"
                      required
                    />
                    <!--                      <v-text-field-->
                    <!--                        prepend-icon="person"-->
                    <!--                        name="email"-->
                    <!--                        type="text"-->
                    <!--                        v-bind="email"-->
                    <!--                        :label="emailPhoneLabel"-->
                    <!--                        :disabled="loading"-->
                    <!--                        :rules="emailRules"-->
                    <!--                        validate-on-blur-->
                    <!--                        required-->
                    <!--                      />-->
                  </v-col>
                </v-row>
                <v-row class="my-0">
                  <v-col class="py-0 px-6">
                    <v-text-field
                      v-model="password"
                      label="Password"
                      prepend-icon="fa-solid fa-lock"
                      color="primary"
                      variant="underlined"
                      class="password-text-field"
                      :type="showPassword ? 'text' : 'password'"
                      :rules="passwordRules"
                      :append-inner-icon="
                        showPassword
                          ? 'fa-solid fa-eye'
                          : 'fa-solid fa-eye-slash'
                      "
                      @click:append-inner="
                        () => (this.showPassword = !showPassword)
                      "
                    />
                    <!--                      <v-text-field-->
                    <!--                        autocomplete="off"-->
                    <!--                        prepend-icon="fa-solid fa-lock"-->
                    <!--                        name="password"-->
                    <!--                        label="Password"-->
                    <!--                        id="password"-->
                    <!--                        v-bind="password"-->
                    <!--                        min="8"-->
                    <!--                        :disabled="loading"-->
                    <!--                        :rules="passwordRules"-->
                    <!--                        :append-icon="-->
                    <!--                          showPassword ? 'visibility' : 'visibility_off'-->
                    <!--                        "-->
                    <!--                        :type="showPassword ? 'text' : 'password'"-->
                    <!--                        @click:append="-->
                    <!--                          () => (this.showPassword = !showPassword)-->
                    <!--                        "-->
                    <!--                        required-->
                    <!--                      />-->
                  </v-col>
                </v-row>
                <!--                </v-form>-->
                <!--              </v-card-text>-->
                <!--              <v-card-text class="mt-n2 pb-1 px-5">-->
                <v-row class="px-4 mt-0">
                  <v-col class="py-4">Stay Logged In?</v-col>
                  <v-col class="py-0">
                    <v-switch
                      v-model="stayLoggedIn"
                      class="switch-align-right"
                      color="primary"
                      hide-details
                    />
                  </v-col>
                </v-row>

                <v-row class="mt-0 px-4">
                  <v-col class="text-center">
                    <span class="font-weight-light">
                      Not registered? Got your invite code?
                      <router-link :to="'/register'">Register Now!</router-link>
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="mt-6 pb-4">
                <v-row
                  column
                  :style="cardActionsHeight"
                  class="px-4 text-center"
                >
                  <v-col cols="12" class="px-4">
                    <v-btn
                      color="primary"
                      class="mb-3 text-none"
                      style="color: white !important"
                      variant="flat"
                      size="large"
                      :loading="loading"
                      :disabled="loading"
                      :block="true"
                      @click="doLogin"
                    >
                      Login
                      <template v-slot:loader>
                        <v-progress-circular
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </template>
                    </v-btn>
                  </v-col>

                  <v-col v-if="isAgentHost" cols="12" class="px-4 py-0">
                    <v-btn
                      color="primary"
                      class="mb-3 text-none"
                      variant="text"
                      size="large"
                      :loading="loading"
                      :disabled="loading"
                      :block="true"
                      @click="doAgentAuthRedirect"
                    >
                      Login with One-Time Password
                      <template v-slot:loader>
                        <v-progress-circular
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </template>
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <span class="mt-4 font-weight-light">
                      <a
                        href="/forgot-password"
                        @click.prevent="forgotPasswordNav"
                      >
                        Forgot Password
                      </a>
                    </span>
                  </v-col>
                </v-row>
              </v-card-actions>
              <v-snackbar
                v-model="alert"
                color="error"
                location="top"
                multi-line
              >
                Whoops, Something went wrong. Try again.
                <template v-slot:action="{ attrs }">
                  <v-btn dark text fab small @click="alert = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </template>
              </v-snackbar>
            </v-card>
            <p class="text-center mt-6">
              <a
                href="https://www.primestreet.io/terms.html"
                target="_blank"
                class="terms mr-6"
              >
                Terms of Use
              </a>
              <a
                href=" https://www.primestreet.io/privacy.html"
                target="_blank"
                class="terms ml-6"
              >
                Privacy Policy
              </a>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import C from "@/utils/constants";
import api from "@/services/api.js";
import useFormatters from "@/mixins/formatters";

const testEmailExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const testPhoneExp = /(\d{1})?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})/;

export default {
  name: "login-form",
  data() {
    return {
      valid: true,
      email: "",
      password: "",
      showPassword: false,
      stayLoggedIn: false,
      loading: false,
      alert: false,
      emailRules: [
        (v) => !!v || this.emailPhoneRequiredErrorMessage,
        (v) =>
          this.validateUserEmailPhone(v) || this.emailPhoneInvalidErrorMessage,
      ],
      passwordRules: [(v) => !!v || "Password is required"],
      keydownEventListener: null,
    };
  },
  props: {
    source: String,
  },
  computed: {
    ...mapGetters("auth", [
      "session",
      "isAuthing",
      "sessionAutoRefresh",
      "codeChallenge",
    ]),
    ...mapGetters("user", [
      "me",
      "agent",
      "myBrokerage",
      "isAdmin",
      "roles",
      "isBrokerAdmin",
      "isAgent",
      "isAgentOnly",
      "isLoanOfficer",
      "isPrimestreetRoleType",
    ]),
    emailPhoneLabel() {
      if (C.AGENT_DOMAINS.includes(window.location.hostname)) {
        return "Phone Number";
      }
      return "Email Address";
    },
    isAgentHost() {
      return C.AGENT_DOMAINS.includes(window.location.hostname);
    },
    cardActionsHeight() {
      return this.isAgentHost ? "144" : "84";
    },
    emailPhoneRequiredErrorMessage() {
      return C.AGENT_DOMAINS.includes(window.location.hostname)
        ? "Phone number is required"
        : "Email is required";
    },
    emailPhoneInvalidErrorMessage() {
      return C.AGENT_DOMAINS.includes(window.location.hostname)
        ? "Invalid phone number."
        : "Invalid e-mail.";
    },
  },
  methods: {
    ...useFormatters(),
    ...mapMutations("auth", ["setSessionAutoRefresh", "setCodeChallenge"]),
    ...mapMutations("user", ["setAgent"]),
    validateUserEmailPhone(i) {
      const validEmail = testEmailExp.test(i);
      const validPhone = testPhoneExp.test(i);

      return validEmail || validPhone;
    },
    doAgentAuthRedirect() {
      const baseUrl = process.env.VUE_APP_API + "/auth/oauth2.0/authorize";
      // const baseUrl = "https://devapi.primestreet.io/auth/oauth2.0/authorize";
      const responseType = "code";
      const clientId = "oauthagents";
      const redirectUri = process.env.VUE_APP_AGENT_DOMAIN;
      const codeChallenge = this.generateUUID();
      this.setCodeChallenge(codeChallenge);
      // Redirect the user to the CAS password-less login
      window.location.href = `${baseUrl}?response_type=${responseType}&client_id=${clientId}&redirect_uri=${redirectUri}&code_challenge=${codeChallenge}`;
    },
    doLogin() {
      this.loading = true;

      let email = this.email.trim().toLowerCase();
      let password = this.password.trim();

      // check if this is a phone number and if so append a '+' and or a '1' for auth
      if (testPhoneExp.test(email)) {
        email = `+1${this.formatPhoneFormInputMask(email)}`;
      }

      if (email && password) {
        this.$store
          .dispatch("auth/login", { email: email, password: password })
          .then((resp) => {
            console.log("doLogin resp: " + resp);
            console.log("The token: " + JSON.stringify(this.session));
            this.loadUser();
            // this.patchLastLogin();
            // this.$gtag.set({
            //   userProperties: {
            //     dimension1: "1234567890",
            //     dimension2: "DevTest",
            //     dimension5: "test_dimension_5_role",
            //   },
            // });
            // this.$gtag.set({
            //   user_properties: {
            //     dimension3: "test_dimension_3",
            //   },
            // });
            // this.$gtag.config({
            //   user_properties: {
            //     dimension8: "test_dimension_8_config",
            //   },
            // });
            // this.$gtag.set({
            //   dimension6: "dimension5_test",
            // });
            // this.$gtag.set({
            //   dimension7: "dimension7_test_event",
            // });
            this.$gtag.event("login_success", {});

            if (this.isAgentHost) {
              this.$gtag.event("agent_login_success", {});
            } else {
              this.$gtag.event("broker_login_success", {});
              // setTimeout(
              //   () =>
              //     this.$gtag.event("broker_login_success", {
              //       dimension6: "Hello_world",
              //     }),
              //   10000
              // );
            }
          })
          .catch((e) => {
            console.log("doLogin error: " + e);
            console.log(e);
            this.alert = true;
            this.loading = false;
            this.$gtag.event("login_error", {});
            if (this.isAgentHost) {
              this.$gtag.event("agent_login_error", {});
            } else {
              this.$gtag.event("broker_login_error", {});
            }
          });
      } else {
        this.alert = true;
        this.loading = false;
      }
    },
    doLoginWithCode(code) {
      // so far this is used for Agent login only
      this.loading = true;
      const uuid = this.codeChallenge;
      if (code.length > 0) {
        this.$store
          .dispatch("auth/loginWithCode", {
            code: code,
            codeVerifier: uuid,
          })
          .then((resp) => {
            console.log("doLogin resp: " + resp);
            console.log("The token: " + JSON.stringify(this.session));

            this.loadUser();

            this.$gtag.event("login_success", {});
            this.$gtag.event("agent_onetime_password", {});
          })
          .catch((e) => {
            console.log(e);
            this.alert = true;
            this.loading = false;
            this.$gtag.event("login_error", {});
            this.$gtag.event("agent_onetime_password_error", {});
          });
      } else {
        this.alert = true;
        this.loading = false;
      }
    },
    generateUUID() {
      // Generate a random hexadecimal string of 32 characters
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          const r = (Math.random() * 16) | 0;
          const v = c === "x" ? r : (r & 0x3) | 0x8; // Set the 'y' character to '8', '9', 'a', or 'b'
          return v.toString(16);
        },
      );
    },
    patchLastLogin() {
      let patch = {
        psiLastLogin: new Date().toISOString(),
      };
      api.user.patchUser(this.me.id, patch);
    },
    async patchAgentDesktopLastAccessed() {
      console.log("patchAgentDesktopLastAccessed");
      if (this.isAgentOnly) {
        console.log("should be patching agent");
        console.log(this.agent);
        const patch = {
          agentDesktopLastAccessed: new Date().toISOString(),
        };
        await api.agent.patch(this.agent.id, patch);
      }
    },
    loadUser() {
      this.$store
        .dispatch("user/loadMe")
        .then(() => {
          if (this.me.roles.length > 0) {
            this.patchLastLogin();

            console.log("!!!!!!!!!!!! roles !!!!!!!!!!!!!!!");
            console.log(this.me.roles);
            let userRoles = this.me.roles
              .map((r) => this.prettyPrintEnum(r.name))
              .join(", ");

            this.$gtag.set({
              user_properties: {
                dimension5: userRoles,
                userId: this.me.id,
              },
            });
            if (this.isAgentOnly) {
              console.log("--- AGENT ONLY ---");
              this.loadBoostStatus();
              this.loadAgent();
            } else if (
              this.isAgent &&
              C.AGENT_DOMAINS.includes(window.location.hostname)
            ) {
              console.log("--- AGENT & DOMAIN ---");
              // the user has the AGENT role AND the domain is an 'agent' domain
              this.$store
                .dispatch("user/maintainRole", C.ROLE.AGENT)
                .then(() => {
                  // this.navigateToConsole();
                  this.loadBoostStatus();
                  this.loadAgent();
                });
            } else if (this.isBrokerAdmin) {
              console.log("--- BROKER ADMIN ---");
              // the user has the BROKER_ADMIN role
              this.$store
                .dispatch("user/maintainRole", C.ROLE.BROKERAGE_ADMIN)
                .then(() => {
                  this.loadBrokerage();
                });
            } else if (this.isLoanOfficer) {
              console.log("--- LOAN OFFICER ---");
              // the user has a LOAN_OFFICE_ROLE type
              this.$store
                .dispatch("user/maintainRoleType", C.ROLE_TYPE.LOAN_OFFICE_ROLE)
                .then(() => {
                  this.loadLoanOffice();
                });
              // this.loadLoanOffice();
            } else if (this.isPrimestreetRoleType) {
              console.log("--- PRIMESTREET ROLE ---");
              // the user has a PRIMESTREET_ROLE type
              this.$store
                .dispatch("user/maintainRoleType", C.ROLE_TYPE.PRIMESTREET_ROLE)
                .then(() => {
                  this.loadLoanOffice();
                });
              // this.navigateToConsole();
            } else {
              console.error("no mapped role type");
              this.alert = true;
              this.loading = false;
            }
          } else {
            console.error("No roles found");
            this.alert = true;
            this.loading = false;
          }
        })
        .catch(() => {
          this.alert = true;
          this.loading = false;
        });
    },
    loadBrokerage() {
      if (this.me.brokerId) {
        this.$store
          .dispatch("user/loadMyBrokerage")
          .then(() => {
            // console.log("After the user/loadMyBrokerage");
            // console.log(this.me.brokerId);
            // console.log(this.myBrokerage.name);

            this.$gtag.set({
              user_properties: {
                dimension3: this.me.brokerId, // brokerage id
                dimension4: this.myBrokerage.name, // brokerage name
              },
            });
            this.navigateToConsole();
          })
          .catch(() => {
            this.alert = true;
            this.loading = false;
          });
      } else {
        this.navigateToConsole();
      }
    },
    loadBoostStatus() {
      this.$store
        .dispatch("user/loadBoostStatus")
        .then(() => {})
        .catch(() => {});
    },
    loadLoanOffice() {
      if (this.me.loanOfficeId) {
        this.$store
          .dispatch("user/loadMyLoanOffice")
          .then(() => {
            this.navigateToConsole();
          })
          .catch(() => {
            this.alert = true;
            this.loading = false;
          });
      } else {
        this.navigateToConsole();
      }
    },
    async loadAgent() {
      try {
        this.loading = true;

        const { data } = await api.agent.get(this.me.agentId);
        this.setAgent(data);

        await this.patchAgentDesktopLastAccessed();

        this.navigateToConsole();
      } catch (e) {
        console.log(e);
        this.alert = true;
      } finally {
        this.loading = false;
      }
    },
    navigateToConsole() {
      this.loading = false;
      if (this.roles.length > 0) {
        let role = this.roles[0];
        if (role in C.ROLE_DEFAULT_ROUTE) {
          console.log("** navigating here 1");
          this.$router.push(C.ROLE_DEFAULT_ROUTE[role]);
        } else {
          console.log("** navigating here 2");
          this.$router.push("console");
        }
      }
    },
    forgotPasswordNav() {
      console.log("forgotPasswordNav");
      this.$gtag.event("forgot_password_link", {});
      this.$router.push("/forgot-password");
    },
  },
  watch: {
    isAuthing() {},
    stayLoggedIn() {
      this.setSessionAutoRefresh(this.stayLoggedIn);
    },
  },
  created() {},
  mounted() {
    this.stayLoggedIn = this.sessionAutoRefresh;

    this.keydownEventListener = (e) => {
      if (e.code === "Enter") {
        this.doLogin();
      }
    };
    document.addEventListener("keydown", this.keydownEventListener);
    if (this.isAgentHost) {
      // Check if the URL contains the 'code' parameter for password less auth
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("code") && this.codeChallenge) {
        this.doLoginWithCode(urlParams.get("code"));
      }
    }
  },
  beforeUnmount() {
    console.log("** LoginForm beforeUnmount");

    this.email = "";
    this.password = "";

    document.removeEventListener("keydown", this.keydownEventListener);
  },
};
</script>

<style scoped>
.switch-align-right :deep(.v-selection-control) {
  justify-content: end !important;
}

.terms {
  color: #818181;
  font-size: 12px;
  text-decoration: none;
}

.password-text-field :deep(.v-field__append-inner) {
  padding-right: 8px;
}
.password-text-field :deep(.v-field__append-inner .v-icon) {
  font-size: 20px;
}
</style>
